import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import ApiService from '../../../../../../../config/api-config';
import { getTrendChartData } from './trendCharts';
import { getTrendChartsPayload } from '../../../../../../../config/reqConfig/anomalyDetection';
import NoDataAvailable from '../../../../../../../common/NoDataAvailable';
import ErrorComponent from '../../../../../../../common/ErrorComponent';
import Spinner from '../../../../../../../common/Spinner';
import ADLineChart from '../../../genericComponents/ADSyncLineChart';
import { backtoSevenDays } from '../../../../../../../utils/displayTime';
import { useLocation } from 'react-router-dom';
import useI18n from "../../../../../../../i18n/useI18n";

const SingleSiteTrendCharts = (props) => {
    const { tViews } = useI18n('views')
    const location = useLocation();
    const [configs, setConfig] = useState(null);
    const [loader, setChartLoader] = useState(null);
    const [error, setChartError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setChartLoader(true);
                let timePeriod = backtoSevenDays();
                const trendPayload = getTrendChartsPayload(timePeriod, props.tunnelName);
                const res = await ApiService.getADSingleSiteTrendCharts(trendPayload);
                if(!res?.errorObject) {
                    let processData = getTrendChartData(res.data.data);
                    setConfig(processData);
                } else {
                    setChartError(res.errorObject);
                }
            } catch (error) {
                setChartError(error.message);
            }
            setChartLoader(false);
        }
       fetchData();
        }, [location])

        return (
            <div
                role="region"
                aria-label={tViews('a11yLabels.singleSiteTrendCharts')}
                aria-live="polite">
                {loader
                    ? <div className="ad-trend-spinner"><Spinner /></div>
                    : error
                        ? <ErrorComponent error={error} />
                        : configs?.length > 0
                            ? (<ADLineChart
                                config={configs}
                                selectedHour={props.selectedHour} />)
                            : (<NoDataAvailable />)
                        
                }
            </div>
        );
}

SingleSiteTrendCharts.propTypes = {
    selectedHour: PropTypes.string,
    tunnelName: PropTypes.string,
};

export default SingleSiteTrendCharts;
